import { IconPlus } from '@tabler/icons-react';
import { Button, Divider, Grid, TextInput, Title } from '@mantine/core';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ErrorMessage from '../../components/ErrorMessage';
import GeneratedLandingMarketingCard from '../../components/GeneratedContent/GeneratedLandingMarketingCard';
import GeneratedLandingTypeCard from '../../components/GeneratedContent/GeneratedLandingTypeCard';
import { generatedContentOptions as options, typeOptionsByChannel } from '../../constants/GeneratedContent';
import useFetch from '../../helpers/useFetch';

const DEFAULT_MODEL = 'sol';
const DEFAULT_PROVIDER = 'rlv';

const GeneratedContentLandingForm = ({ parentContent, onSubmit }) => {
  const { domain } = useSelector((state) => state.domain);
  const fetch = useFetch();
  const [marketingChannel, setMarketingChannel] = useState();
  const [type, setType] = useState();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [marketingOptions, setMarketingOptions] = useState(options);
  const [userError, setUserError] = useState();

  const selectMarketingChannel = (option) => {
    setUserError(null);

    if (!option) {
      setMarketingChannel(null);
      setType(false);
      setMarketingOptions([...options]);
      return;
    }

    setMarketingChannel(option.marketingChannel);
    setMarketingOptions((prev) => prev.filter((p) => p.marketingChannel === option.marketingChannel));
  };

  const createContent = () => {
    setUserError(null);
    setLoading(true);

    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/generatedContent`, {
      method: 'POST',
      body: JSON.stringify({
        type,
        marketingChannel,
        name,
        parentId: parentContent?.marketingChannel === 'folder' ? parentContent?.id : parentContent?.parentId,
        model: DEFAULT_MODEL,
        provider: DEFAULT_PROVIDER,
      }),
    })
      .then(({ generatedContent }) => onSubmit(generatedContent))
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const isCreateContentDisabled =
    loading || !marketingChannel || (!type && typeOptionsByChannel[marketingChannel]?.length > 0) || !name;

  const handleEnterClick = (e) => {
    if (e.key === 'Enter' && e.shiftKey === false) {
      e.preventDefault();

      if (!isCreateContentDisabled) {
        createContent();
      }
    }
  };

  return (
    <Grid>
      <Grid.Col span={12}>
        <Grid>
          {marketingOptions.map((option, index) => (
            <GeneratedLandingMarketingCard
              key={index}
              option={option}
              marketingChannel={marketingChannel}
              selectMarketingChannel={selectMarketingChannel}
            />
          ))}
        </Grid>
        {typeOptionsByChannel[marketingChannel]?.length > 0 ? (
          <>
            <Title order={2}>What type of marketing channel would you like to create?</Title>
            <Divider my="sm" />
            <Grid>
              {typeOptionsByChannel[marketingChannel].map((option, index) => (
                <GeneratedLandingTypeCard
                  key={index}
                  option={option}
                  type={type}
                  selectType={({ value }) => setType(value)}
                />
              ))}
            </Grid>
          </>
        ) : null}
        <Grid mb="md">
          <Grid.Col>
            <TextInput
              size="lg"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleEnterClick}
              placeholder="Enter content name..."
            />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col>
            <Button size="lg" fullWidth onClick={createContent} disabled={isCreateContentDisabled}>
              <IconPlus size={14} /> Create
            </Button>
            {userError && <ErrorMessage message={userError.message} />}
          </Grid.Col>
        </Grid>
      </Grid.Col>
    </Grid>
  );
};

export default GeneratedContentLandingForm;
